import type { InstantConfigValue } from "./config";
import type {
  BucketingResult,
  GroupMarker,
  KeyValuesProvider,
} from "./matchers";

/**
 * Creates a list of key-value pairs based on bucketing rules.
 *
 * Additionally, reads mapped (via icLABradorGamKeyValues flag) key-value pairs for boolean flags (deprecated).
 * The default value, e.g. where nothing was mapped to any group gets variable name as key.
 */
export const labradorKeyValuesMapper = (
  icLABradorGamKeyValues: InstantConfigValue | undefined,
): GroupMarker & KeyValuesProvider => {
  const deprecatedKeyValueNamesMap: Record<string, string> = Array.isArray(
    icLABradorGamKeyValues,
  )
    ? icLABradorGamKeyValues
        .map((v) => v && v.toString().split(":"))
        .filter((v) => v && v.length >= 2)
        .reduce((acc, v) => {
          acc[v[0]] = v[1];
          return acc;
        }, {})
    : {};

  const getKeyVal = (bucketingResult: BucketingResult): string | undefined =>
    bucketingResult?.isActive
      ? bucketingResult.keyVal
      : bucketingResult?.defaultKeyVal;

  const keyValues: string[] = [];
  const labradorKeyValues: string[] = [];

  return {
    mark(bucketingResult: BucketingResult) {
      const keyVal = getKeyVal(bucketingResult);

      if (keyVal && !labradorKeyValues.includes(keyVal)) {
        labradorKeyValues.push(keyVal);
      }
    },
    /**
     * @deprecated
     */
    deprecatedMark: (key: string, sampling: number, active: boolean) => {
      const traffic = active ? sampling : 100 - sampling;
      const group = active ? "B" : "A";
      const keyValue = `${key}_${group}_${traffic}`;
      const labradorKeyValue = deprecatedKeyValueNamesMap[keyValue] ?? keyValue;

      if (!keyValues.includes(keyValue)) {
        keyValues.push(keyValue);
      }
      if (!labradorKeyValues.includes(labradorKeyValue)) {
        labradorKeyValues.push(labradorKeyValue);
      }
    },
    getKeyValues: () => keyValues,
    getLabradorKeyValues: () => labradorKeyValues,
  };
};
